import { Component, Input, OnInit } from '@angular/core';
import { MenuItem, MessageService } from 'primeng/api';
import saveAs from 'file-saver';
import { first } from 'rxjs';
import { ReportsService } from 'src/app/services/reports.service';
import { ActivityRecordService } from 'src/app/services/activity-record.service';
import { CryptoJsService } from 'src/app/services/crypto-js.service';


@Component({
  selector: 'app-subsidy-distribution-drill-down-report',
  templateUrl: './subsidy-distribution-drill-down-report.component.html',
  styleUrls: ['./subsidy-distribution-drill-down-report.component.scss']
})
export class SubsidyDistributionDrillDownReportComponent implements OnInit {

  @Input() drillDownReqDetails: any;

  public userId: any;
  public appVerificationItems: MenuItem[];
  public reportData: any;
  public reportName: any = '';
  public reportYear: any = '';
  public loading: boolean = false;
  public subjectSub: any;
  public subscriptions: any = [];

  constructor(
    private reportsService: ReportsService,
    private messageService: MessageService,
    private activityRecordService: ActivityRecordService,
    private cryptoJsService: CryptoJsService
  ) { }

  ngOnInit(): void {
    let sessionToken = this.cryptoJsService.DecryptToken(sessionStorage.getItem('token'));
    let payload = atob(JSON.parse(sessionToken).authToken?.split('.')[1]);
    this.userId = JSON.parse(payload)?.sub;

    this.appVerificationItems = [
      {
        label: 'Download excel', icon: 'pi pi-fw pi-download', command: () => {
          this.exportExcel(this.reportData, `${this.reportName} (Financial Year: ${this.reportYear})`);
        }
      },
      // {
      //   label: 'Download Pdf', icon: 'pi pi-fw pi-download', command: () => {
      //     this.downloadSheetAsPdf(this.reportData, "LOT_report");
      //   }
      // },
    ];

    this.loadData();
  }

  loadData() {
    this.reportName = this.drillDownReqDetails?.selectedRow?.Activities;
    
    let val = this.drillDownReqDetails?.selectedRow;
    let finyear = '';
    if(this.drillDownReqDetails?.formatType == 2 || this.drillDownReqDetails?.formatType == 4){
      finyear = val?.['F.Y.'];
    }else if(this.drillDownReqDetails?.formatType == 3 || this.drillDownReqDetails?.formatType == 5 || this.drillDownReqDetails?.formatType == 6){
      // const filteredKeys = Object.keys(val).filter(key => key !== "Apps" && key.endsWith("Apps"));
      // console.log(filteredKeys);
      finyear = this.drillDownReqDetails?.finYear;
    }

    this.reportYear = finyear;
    
    let reqBody = {
      "paymentFinYear": finyear,
      "status": this.drillDownReqDetails?.status,
      "activityName": val?.Activities,
      "formatType": this.drillDownReqDetails?.formatType,
      "casteDesc":  val?.Caste_Description ? val?.Caste_Description : '',
      "programName": val?.Program_Name ? val?.Program_Name : '',
    }

    this.loading = true;
    let sub = this.reportsService.getSubsidyDistributionDrillDown(reqBody)
      .pipe(first())
      .subscribe({
        next: (data) => {
          // this.activityRecordService.activityRecord(this.userId, `Subsidy Distribution Drill Down Report (${this.reportName})`, '', new Date(), 'Success');
          this.loading = false;
          if (data?.length > 0) {
            this.reportData = data;
          } else {
            this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Data Not Available' });
            this.reportData = [];
          }
        },
        error: (err) => {
          this.loading = false;
          this.reportData = [];
          // this.activityRecordService.activityRecord(this.userId, `Subsidy Distribution Drill Down Report (${this.reportName})`, '', new Date(), err);

          this.messageService.add({ severity: 'error', summary: 'Error Message', detail: err });
        }
      });
    this.subscriptions.push(sub);
  }

  ngOnDestroy(){
    this.subscriptions.forEach(sub => sub.unsubscribe());
    if(this.subjectSub){
      this.subjectSub.unsubscribe()
    }
  }

  exportExcel(modelData, filename) {
    if (!modelData) {
      modelData = [];
    }
    import("xlsx").then(xlsx => {
      let dataToSave = modelData.map((d: any) => {
        return {
          'Payment Fin Year': d.PaymentFinYear,
          'App Id': d.AppID,
          'Lot No': d.Lot_No,
          'Program_Name': d.Program_Name,
          'Status': d.Status,
          'State_share_amt': d.State_share_amt,
          'Centre_share_amt': d.Centre_share_amt,
          'TopUp': d.TopUp,
          'aby': d.aby,
          'Refund_to_Farmer': d.Refund_to_Farmer,
          'FarmerShare_to_Vendor': d.FarmerShare_to_Vendor,
          'Remarks': d.Remarks,
          'CAORemarks': d.CAORemarks,
        }
      })

      const worksheet = xlsx.utils.json_to_sheet(dataToSave);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
      const excelBuffer: any = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array"
      });
      this.saveAsExcelFile(excelBuffer, filename);
    });
  }

  saveAsExcelFile(buffer: any, fileName: string): void {
    import("file-saver").then(FileSaver => {
      let EXCEL_TYPE =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
      let EXCEL_EXTENSION = ".xlsx";
      const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE
      });
      saveAs(
        data,
        fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION
      );
    });
  }

}
